<div class="dp-info-bar-wrap info-type-{{infoType}}">
	<div class="dp-info-bar-content">
        <div class='info-bar-icon' *ngIf='icon != null'>
            <fa-icon [icon]='icon'></fa-icon>
        </div>
        <div class='info-bar-text'><ng-content></ng-content></div>
	</div>
</div>
